import React from 'react';
import './LoadingIndicator.css';

const LoadingIndicator = () => {
  return (
    <div className="LoadingIndicator">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingIndicator;
